import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import dict from '@/mixins/component-dict';
export default {
  name: 'd2-dict',
  mixins: [dict],
  props: {
    // 标签名
    tag: {
      type: String,
      default: 'span',
      required: false
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(this.tag, {
      "attrs": _objectSpread({}, this.attrs)
    }, [this.currentLabel]);
  }
};